import styled from 'styled-components';

import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import { breakPoints } from '~/src/constants/breakpoints';

export const BlocksContainer = styled.div`
  display: flex;
  flex-wrap: nowrap;
  gap: 24px;
  width: 100%;
  margin-top: 48px;

  @media (max-width: ${breakPoints.mobile}) {
    flex-direction: column;
  }
`;

export const Block = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 8px;
  background: ${COLORS.BgMain}0D;
  border-radius: 24px;
  padding: 28px 38px 31px 38px;
  width: 100%;

  @media (max-width: ${breakPoints.tablet}) {
    padding: 14px 19px 20px 19px;
  }

  @media (max-width: ${breakPoints.mobile}) {
    padding: 32px 6px 27px 6px;
    align-items: center;
    row-gap: 12px;
  }
`;

export const Title = styled.div`
  ${FONTS.H3};
  color: ${COLORS.TextWhite};

  @media (max-width: ${breakPoints.sDesktop}) {
    ${FONTS.H4};
  }

  @media (max-width: ${breakPoints.mobile}) {
    ${FONTS.H3};
    text-align: center;
  }
`;

export const Description = styled.div`
  ${FONTS.S};
  color: ${COLORS.TextWhite};

  @media (max-width: ${breakPoints.sDesktop}) {
    ${FONTS.XS};
  }

  @media (max-width: ${breakPoints.tablet}) {
    ${FONTS.XXS};
  }

  @media (max-width: ${breakPoints.mobile}) {
    ${FONTS.XS};
    text-align: center;
  }
`;
